import { createStore } from 'vuex'
const store = createStore({
  state () {
    return {
      token: localStorage.getItem('token') || ""
    }
  },
  mutations: {
    saveToken (state,token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    removeToken(state){
        state.token = ""
        localStorage.removeItem('token')
    }
  },
  actions: {
    saveToken({commit},token){
        commit("saveToken",token)
    },
    removeToken({commit}){
        commit("removeToken")
    }
  },
  getters: {
    getToken(state){
        return state.token
    }
  }
})

export default store
